<template lang="pug">
  #program-questions
    WtTile(ancestor vertical :col="12")
      WtTile(parent)
        WtTile(child :col="12")
          BNotification(
            v-if="$auth.user().isWtAdmin"
            type="is-danger"
            role="alert"
            has-icon
            icon="information"
            :closable="false"
          ) Only WT Admins Can See Below
          WtTitle(h4) Questions - Admin Super Duper
          span.has-text-weight-light {{ descriptionText }}
          .block.is-flex.is-align-items-center.mt-2
            BIcon(icon="information" type="is-danger" size="is-medium" class="mr-2")
            span.has-text-weight-light {{ infoText }}
          WtButton(
            :loading="addDefaultQuestionLibraryProcessing"
            v-if="$auth.user().isWtAdmin"
            @click.native="addDefaultQuestionLibrary"
          ) {{ `ADD DEFAULT QUESTION LIBRARY TO THIS PROGRAM: ${$auth.user().program.url}` }}
          p After clicking, refresh the page to see that the question library is updated.  Questions by default are 'not active' and 'not required'.
      WtTile(:col="12")
        WtTile(parent :col="6" vertical)
          WtTile(child :col="12")
            WtButton(
              v-if="!createQuestion"
              :fullwidth="true"
              @click.native="createQuestion = true"
            ) CREATE A NEW QUESTION
            .block(v-if="createQuestion")
              QuestionBuilderAdminSuper(
                @cancel="createQuestion = false; $scrollTo('#admin-tabs')"
              )
        WtTile(parent :col="6" vertical :is-loading="!programQuestionsLoaded")
          WtTile(child :col="12")
            WtTitle(h4) Existing Questions
              .block(class="mt-3 mb-4" v-if="programQuestionsLoaded")
                QuestionViewAdminSuper(
                  :data="item"
                  :key="item.id"
                  v-for="item in publishedQuestions"
                )
                .has-text-centered.is-size-6(v-if="!publishedQuestions.length")
                  span.has-text-grey No questions...
            WtTitle(h4) Draft Questions
              .block(class="mt-3" v-if="programQuestionsLoaded")
                QuestionViewAdminSuper(
                  :data="item"
                  :key="item.id"
                  v-for="item in draftQuestions"
                )
                .has-text-centered.is-size-6(v-if="!draftQuestions.length")
                  span.has-text-grey No questions...
            WtTitle(h4) Wellness Challenge Questions
              .block(class="mt-3" v-if="programQuestionsLoaded")
                QuestionViewAdminSuper(
                  :data="item"
                  :key="item.id"
                  v-for="item in wellnessQuestions"
                )
                .has-text-centered.is-size-6(v-if="!wellnessQuestions.length")
                  span.has-text-grey No questions...
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import QuestionViewAdminSuper from "./QuestionViewAdminSuper";
import QuestionBuilderAdminSuper from "./QuestionBuilderAdminSuper";

export default {
  name: "ProgramQuestionsAdminSuper",

  components: {
    WtButton,
    WtTitle,
    WtTile,
    QuestionViewAdminSuper,
    QuestionBuilderAdminSuper
  },

  data() {
    return {
      descriptionText:
        "Our question interface allows you to ask your walkers questions during the course of the program or at registration.",
      infoText:
        "Under GDPR, HIPAA, GINA, ADA, ACA, and other rulings protected information (including family history) should not be asked of participants in a wellness program.",
      createQuestion: false,
      addDefaultQuestionLibraryProcessing: false
    };
  },

  computed: {
    ...mapGetters("program", ["programQuestions", "programQuestionsLoaded"]),

    notWellnessQuestions() {
      return this.programQuestions.filter(q => !q.isWellnessChallenge);
    },

    wellnessQuestions() {
      return this.programQuestions.filter(q => q.isWellnessChallenge);
    },

    draftQuestions() {
      return this.notWellnessQuestions.filter(q => q.draft);
    },

    publishedQuestions() {
      return this.notWellnessQuestions.filter(q => !q.draft);
    }
  },

  mounted() {
    const programId = this.$auth.user().programId;
    this.fetchProgramQuestions({ programId });
  },

  methods: {
    ...mapActions("program", ["fetchProgramQuestions"]),

    async addDefaultQuestionLibrary() {
      try {
        this.addDefaultQuestionLibraryProcessing = true;
        await this.axios.post(
          `super/programs/${
            this.$auth.user().programId
          }/addDefaultQuestionLibrary`
        );
      } catch (error) {
        console.log("error: ", error);
      }
      this.addDefaultQuestionLibraryProcessing = false;
    }
  }
};
</script>

<style lang="sass" scoped></style>
